import { AxiosResponse } from "axios";
import { api } from '../../api';
import { GenericDeleteResponse, StandardResponse } from "../../interfaces/Common";
import { DEFAULT_PAGE_LIMIT } from "../../../utils/constants";
import { ExamByExamCode, Examinee, PaginatedExaminees, PartialEditExamineeFormRequest } from "../../interfaces/preboard/Examinee";

export interface GetExamineeParams {
    keyword?: string;
    page?: number;
    limit?: number;
}

export async function getExaminees(params?: GetExamineeParams): Promise<StandardResponse<PaginatedExaminees>> {
    const response: AxiosResponse<StandardResponse<PaginatedExaminees>> = await api.get("/preboard/examinees", {
        params: {
            ...params,
            limit: params?.limit || DEFAULT_PAGE_LIMIT,
        }
    });
    return response.data;
}

export async function getExamsByExamCode(examineeId: string, examCode: string): Promise<StandardResponse<ExamByExamCode>> {
    const response: AxiosResponse<StandardResponse<ExamByExamCode>> = await api.get(`/preboard/examinees/${examineeId}/codes/${examCode}`);
    return response.data;
}

export async function updateExaminee(examineeId: string, request: PartialEditExamineeFormRequest): Promise<StandardResponse<Examinee>> {
    const response: AxiosResponse<StandardResponse<Examinee>> = await api.put(`/preboard/examinees/${examineeId}`, request);
    return response.data;
}

export async function deleteExaminee(examineeId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/preboard/examinees/${examineeId}`);
    return response.data;
}


export async function deleteExamAttempt(attemptId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/preboard/exams/attempts/${attemptId}`);
    return response.data;
}
